var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 31.293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Unione_6",
    "data-name": "Unione 6",
    d: "M24559.428,23057.295a4.79,4.79,0,0,1-4.787-4.781v-13.977h-.143a1.5,1.5,0,0,1-1.5-1.5v-6.334a1.5,1.5,0,0,1,1.5-1.5h5.713v-1.7a1.5,1.5,0,0,1,1.5-1.5h8.574a1.5,1.5,0,0,1,1.5,1.5v1.7h5.719a1.5,1.5,0,0,1,1.5,1.5v6.334a1.5,1.5,0,0,1-1.5,1.5h-.143v13.977a4.794,4.794,0,0,1-4.787,4.781Zm-1.783-4.781a1.785,1.785,0,0,0,1.783,1.783h13.145a1.789,1.789,0,0,0,1.783-1.783v-13.977h-16.711Zm18.357-16.98v-3.332h-5.719a1.5,1.5,0,0,1-1.5-1.5v-1.7h-5.57v1.7a1.5,1.5,0,0,1-1.506,1.5H24556v3.332h20Z",
    transform: "translate(-24553 -23026.002)",
    fill: "#a5a9c7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOutlined);
export default __webpack_public_path__ + "static/media/delete-outlined.005111ab.svg";
export { ForwardRef as ReactComponent };